import React from "react"

import { styled } from "@mui/material"

import { useTranslations } from "@cirrus/core/i18n/provider"

import { FormTitle } from "../../components/FormTitle"

export const SchoolyearEndScreenContent = () => {
  const { i18n } = useTranslations()

  return (
    <Container>
      <FormTitle>{i18n("Schoolyear:SessionEnded")}</FormTitle>
    </Container>
  )
}

const Container = styled("div")({
  display: "grid",
  rowGap: "20px",
})
